import { ReactNode } from "react";
import { buildClasses } from "../utils/buildClasses";
import { RyeIcon } from "./RyeIcon";

export const RYE_MAIN_CONTENT_SPACER_SIZE = { sm: 1, lg: 4 } as const;

export function RyeMainContentSpacer({
  direction,
  thickness = "sm",
  showHandle = false,
  onHandleClicked,
  children,
}: {
  direction: "h" | "v";
  thickness?: "sm" | "lg";
  showHandle?: boolean;
  onHandleClicked?: () => void;
  /** Optional interaction surface, such as the split-pane resize separator. */
  children?: ReactNode;
}): JSX.Element {
  return (
    <div
      className={buildClasses(
        {
          if: direction === "h",
          then: buildClasses("w-full"),
          else: buildClasses("h-full"),
        },
        "flex-grow-0",
        "flex-shrink-0",
        showHandle || children != null ? "relative" : "",
        children != null ? "z-30" : "",
      )}
      style={{
        [direction === "h" ? "height" : "width"]:
          RYE_MAIN_CONTENT_SPACER_SIZE[thickness],
      }}
    >
      {children}
      {showHandle && (
        <SpacerHandle direction={direction} onHandleClicked={onHandleClicked} />
      )}
    </div>
  );
}

function SpacerHandle({
  direction,
  onHandleClicked,
}: {
  direction: "h" | "v";
  onHandleClicked?: () => void;
}): JSX.Element {
  return (
    <div
      onClick={onHandleClicked}
      className={buildClasses(
        {
          if: direction === "h",
          then: buildClasses(
            "w-16",
            "h-2",
            "duration-200",
            "top-1/2",
            "left-1/2",
            "-translate-x-1/2",
            "-translate-y-1/2",
            "hover:h-4",
            "hover:w-20",
            "group",
          ),
          else: buildClasses(
            "w-0.5",
            "h-8",
            "top-1/2",
            "left-1/2",
            "-translate-x-1/2",
            "-translate-y-1/2",
          ),
        },
        "absolute",
        "bg-surface-100",
        "border-tiny",
        "border-on-surface-400",
        "shadow-sm",
        "z-50",
        "rounded-full",
        "transition-all",
        "flex",
        "items-center",
        "justify-center",
        "hover:cursor-pointer",
      )}
    >
      {direction === "h" && (
        <RyeIcon
          name="keyboard_arrow_down"
          size="sm"
          className={buildClasses(
            "opacity-0",
            "group-hover:opacity-100",
            "transition-opacity",
            "duration-200",
            "text-on-surface-500",
          )}
        />
      )}
    </div>
  );
}
